import { createReducer } from 'redux-act';
import {requestSpendTimeData, responseSpendTimeData} from './action';


const defaultState = {
	requestProcess: false,
};

const reducer = createReducer({

	[requestSpendTimeData]: (state) => {
    return {
      requestProcess: true,
	  	data: [],
    };
  },

  [responseSpendTimeData]: (state, params) => {
		return {
			requestProcess: false,
			data: params,
		};
	},


}, defaultState);



export default reducer
